import { motion, useReducedMotion } from "framer-motion";
import { useI18n } from "../lib/i18n";

export function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const M = motion[as];
  return (
    <M className={className} initial={reduce ? false : { opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </M>
  );
}

export function SectionHead({ eyebrow, title, sub, action, className = "" }) {
  return (
    <Reveal className={`mb-12 flex flex-col gap-6 md:flex-row md:items-end md:justify-between ${className}`}>
      <div className="max-w-2xl">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <h2 className="h-display text-3xl sm:text-4xl lg:text-5xl">{title}</h2>
        {sub && <p className="mt-4 text-base text-fg/60 md:text-lg">{sub}</p>}
      </div>
      {action}
    </Reveal>
  );
}

export function PageHero({ eyebrow, title, sub, image, children }) {
  return (
    <section className="relative overflow-hidden border-b border-cta/10 pb-16 pt-36 md:pb-20 md:pt-44">
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" />}
      <div className="absolute inset-0 bg-gradient-to-b from-canvas/70 via-canvas/80 to-canvas" aria-hidden="true" />
      <div className="mashrabiya absolute inset-0 opacity-[0.05]" aria-hidden="true" />
      <div className="container-lux relative">
        <Reveal>
          {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
          <h1 data-testid="page-title" className="h-display max-w-4xl text-4xl sm:text-5xl lg:text-6xl">{title}</h1>
          {sub && <p className="mt-5 max-w-2xl text-base text-fg/65 md:text-lg">{sub}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}

export const DemoBadge = ({ label, className = "", testid = "demo-badge" }) => {
  const { t } = useI18n();
  return <span data-testid={testid} className={`badge-demo ${className}`}>{label || t("common.demo")}</span>;
};

export const Loading = () => {
  const { t } = useI18n();
  return <div data-testid="loading-state" className="container-lux flex min-h-[50vh] items-center justify-center pt-24 text-sm text-fg/50"><span className="animate-pulse">{t("common.loading")}</span></div>;
};

export const ErrorState = () => {
  const { t } = useI18n();
  return <div data-testid="error-state" className="container-lux flex min-h-[40vh] items-center justify-center pt-24 text-sm text-fg/60">{t("common.error")}</div>;
};
